export const Banner_Animation_Time = 0.5

export const Side_Margin = '8%'

export const boxShadow = '0 4px 14px 0 #1A041B0F'
